export function validOTP(field) {
    const otp = /^[0-9]{6}$/;
    return otp.test(field) ? true : false;
}
